import { render, staticRenderFns } from "./ModalAdicionarDescontos.vue?vue&type=template&id=3706ae4f&"
import script from "./ModalAdicionarDescontos.vue?vue&type=script&lang=js&"
export * from "./ModalAdicionarDescontos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports